import React from 'react';
import {AccordionSummary, AccordionDetails, Stack, Typography, useTheme} from '@mui/material';

import Icon from 'presentation/icons';
import {StyledAccordion} from './styles';
import {AccordionDataProps} from './types';

export function Accordion({title, subtitle, children, dataTagId}: AccordionDataProps) {
	const theme = useTheme();

	return (
		<StyledAccordion>
			<AccordionSummary
				expandIcon={
					<Icon name="expand-more-filled" color={theme.palette.primary.main} size={20} />
				}
				aria-controls="panel1-content"
				id="panel1-header"
				sx={{px: 0, m: 0, justifyContent: 'end'}}
				data-tag-id={dataTagId}>
				<Stack gap={0.5}>
					<Typography variant="subtitle2" color={theme.palette.primary.main}>
						{title}
					</Typography>
					<Typography variant="subtitle1">{subtitle}</Typography>
				</Stack>
			</AccordionSummary>
			<AccordionDetails sx={{px: 0}}>
				<Stack spacing={2}>{children}</Stack>
			</AccordionDetails>
		</StyledAccordion>
	);
}
